import { ref, onBeforeMount, Ref, watch, computed } from 'vue';

interface Column {
  props: {
    field: string;
    frozen?: unknown;
  };
}

export function useColumnFreezing(
  columns: Ref<Column[]>,
  showFreeze: Ref<boolean>
) {
  const frozenColumnsState = ref<{ [key: string]: boolean }>({});

  const freezedColumns = computed(() => {
    return Object.keys(frozenColumnsState.value).filter(
      (key) => frozenColumnsState.value[key]
    );
  });

  const maxFrozenColumns = computed(() => {
    return 4;
  });

  watch(showFreeze, (newValue) => {
    if (!newValue) {
      for (const key in frozenColumnsState.value) {
        frozenColumnsState.value[key] = false;
      }
    }
  });

  onBeforeMount(() => {
    // Initialize frozenColumnsState based on columns provided
    columns.value.forEach((column) => {
      const field = column.props.field;
      if (!(field in frozenColumnsState.value)) {
        // Mark as frozen if column.props.frozen is defined
        frozenColumnsState.value[field] = column.props.frozen !== undefined;
      }
    });
  });

  function toogleFreezeColumn(field: string) {
    frozenColumnsState.value[field] = !frozenColumnsState.value[field];
  }

  function isColumnFreezed(field: string) {
    if (field === 'actions') {
      return Object.values(frozenColumnsState.value).every((v) => v);
    }
    return frozenColumnsState.value[field];
  }

  function canNotFreezeWithMax(field: string) {
    return (
      freezedColumns.value.length >= maxFrozenColumns.value &&
      !freezedColumns.value.includes(field)
    );
  }

  return {
    frozenColumnsState,
    canNotFreezeWithMax,
    toogleFreezeColumn,
    isColumnFreezed,
  };
}
